import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const getOrders = async () => {
  try {
    const response = await axios.get(`${BACKEND}/getOrders`);
    return response.data;
  } catch (error) {
    console.error("Error fetching orders:", error);
    throw error;
  }
};
